// Unified service for employee update operations
import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type { EmployeeProfile, LC_UpdateEmployeeOut } from '../types';
import { mapEmployeeProfileToUpdateRequest } from '../mappers';

/**
 * Service class for employee update operations
 */
export class EmployeeUpdateService {
  /**
   * Update complete employee profile (all tabs unified)
   * PUT /v{version}/Employees/{employeeId}
   */
  async update(profile: EmployeeProfile): Promise<ApiResponse<LC_UpdateEmployeeOut>> {
    const payload = mapEmployeeProfileToUpdateRequest(profile);
    return apiClient.put<LC_UpdateEmployeeOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEES.UPDATE(profile.id),
      payload,
    );
  }
}

export const employeeUpdate = new EmployeeUpdateService();
